import qs from 'qs'

export default {

  truncate (str, maxLength) {
    if (str.length <= maxLength) {
      return str
    }
    return str.slice(0, maxLength) + '...'
  },

  formDataToString (formData) {
    const obj = Object.fromEntries(formData.entries())
    return qs.stringify(obj)
  },

  validPackage (pkg) {
    return /^(?:[a-zA-Z_][a-zA-Z0-9_]*\.){1,}[a-zA-Z_][a-zA-Z0-9_]*$/.test(pkg)
  },

  validBrand (brand) {
    return /^[a-zA-Z][a-zA-Z0-9 _-]*$/.test(brand)
  },

  validModel (model) {
    return /^[a-zA-Z0-9][a-zA-Z0-9 _-]*$/.test(model)
  },

  disabledDate (time) {
    return time.getTime() < new Date().setHours(0, 0, 0, 0)
  },

  isPastTime (dateTime) {
    return new Date(dateTime).getTime() < Date.now()
  },

  isSameDay (date1, date2) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    )
  },

  formatUnixtime (unixtime) {
    const millis = String(unixtime).length === 10 ? +unixtime * 1000 : +unixtime
    const d = new Date(millis)
    return d.toLocaleString('sv-SE').replace(' ', ' ')
  },

  dateToUnixtime (date) {
    return Math.floor(date.getTime() / 1000)
  },

  unixtimeToDate (unixtime) {
    if (!unixtime) return null
    if (unixtime === '0') return new Date()
    return new Date(+unixtime * 1000)
  },

  async copyToClipboard (text, callback) {
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        console.log('Clipboard API ready')
        await navigator.clipboard.writeText(text)
        if (callback) callback()
        console.log('Clipboard API success')
        return
      }
    } catch (err) {
      console.warn('Clipboard API failed', err)
    }

    // 降级方案
    console.log('degrade: use execCommand')
    const textarea = document.createElement('textarea')
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()
    try {
      document.execCommand('copy')
      if (callback) callback()
    } catch (err) {
      if (callback) callback(err)
    }
    document.body.removeChild(textarea)
  }

}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js